import React, { useContext, useState } from 'react';
import { useComponentLogger } from '@/lib/component-logger';
import { useNavigate } from 'react-router-dom';
import DataContext from '@/contexts/DataContext';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { CaretDown as CaretDownIcon } from '@phosphor-icons/react/dist/ssr/CaretDown';
import { CaretRight as CaretRightIcon } from '@phosphor-icons/react/dist/ssr/CaretRight';
import Collapse from '@mui/material/Collapse';

import IconButton from '@mui/material/IconButton';
import { TreeStructure as TreeStructureIcon } from '@phosphor-icons/react/dist/ssr/TreeStructure';


import { TreeForm } from './tree-form';
import { Typography } from '@mui/material';

export function TreeAccordion({treeObject={}, treeParams={}, setTreeParams, onParentOK=() => {}}) {
    const logger = useComponentLogger("Tree Accordion");
    const [open, setOpen] = useState(false);
    const [selectedPointCount, setSelectedPointCount] = useState(0);
    const headerPaddingBottom = open ? {paddingBottom: '0'} : {}
    const onAccordionCancel = () => {
        setOpen(false);
    }

    const onAccordionOK = (selectedPoints) => {
        setOpen(false);
        onParentOK(selectedPoints);
    }


    return (
    <Box sx={{ bgcolor: 'none', p: 0,}}>
        <Card>
        <CardHeader 
            avatar={ <TreeStructureIcon size={24}/> } 
            // show the number of points (leaves) selected
            title={`Select data points (${selectedPointCount} selected)`}
            action={
                <IconButton aria-label='collapse/expand button' onClick={() => {setOpen(!open)}} >
                    {open ? <CaretDownIcon /> : <CaretRightIcon />}
                </IconButton>
            }
            sx={headerPaddingBottom}
            // sx={{paddingBottom: headerPaddingBottom, paddingTop: headerPaddingVertical}}
            onClick={() => {setOpen(!open)}}
            />
        {/* when unmountOnExit is true, causes the content to re-render everytime it's opened, which would cause our data to be refetched everytime? */}
        <Collapse in={open} timeout="auto" unmountOnExit={false}> 
            <CardContent sx={{height: '100%'}}>
                <Stack spacing={2}>
                    <TreeForm treeObject={treeObject} treeParams={treeParams} setTreeParams={setTreeParams} onParentCancel={onAccordionCancel} onParentOK={onAccordionOK} selectedPointCount={selectedPointCount} setSelectedPointCount={setSelectedPointCount} />
                </Stack>
            </CardContent>
        </Collapse>
        </Card>
    </Box>
    );
}
